export const TermsKeys = {
  FETCH_TERMS: () => ['terms', 'fetchTerms'],
  FETCH_PRIVACY: () => ['terms', 'fetchPrivacy']
};
